document.addEventListener('click', function (event) {
  const button = event.target.closest('button, a');

  if (!button) return;

  const buttonText = button.textContent.trim().toLowerCase();

  if (!buttonText.includes('move to cart')) return;

  const wishlistCard = button.closest('.product-card, .card, li');

  updateCartCountInstantly();
  hideWishlistCard(wishlistCard);

  setTimeout(refreshCartCount, 1200);
  setTimeout(refreshCartCount, 2500);
  setTimeout(refreshCartCount, 4000);
});

function updateCartCountInstantly() {
  const cartCount = document.querySelector('cart-count');

  if (!cartCount) return;

  const currentCount = parseInt(cartCount.textContent.trim(), 10) || 0;
  const newCount = currentCount + 1;

  cartCount.hidden = false;
  cartCount.textContent = newCount > 99 ? '99+' : newCount;
}

function hideWishlistCard(wishlistCard) {
  if (!wishlistCard) return;

  wishlistCard.style.opacity = '0';
  wishlistCard.style.transform = 'scale(0.95)';
  wishlistCard.style.transition = 'all 0.25s ease';

  setTimeout(function () {
    wishlistCard.style.display = 'none';
  }, 250);
}

function refreshCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          cart: cart
        });
      }

      const cartCount = document.querySelector('cart-count');

      if (cartCount) {
        cartCount.hidden = cart.item_count === 0;
        cartCount.textContent = cart.item_count > 99 ? '99+' : cart.item_count;
      }
    })
    .catch(error => {
      console.log('Cart count refresh failed:', error);
    });
}